import { DisclaimerType, IDisclaimer } from '@/modules/case';

import PoweredByDisclaimer from './poweredByDisclaimer';

type Props = {
  assetsBaseUrl: string;
  disclaimer: IDisclaimer;
};

export function DisclaimerView({ disclaimer, assetsBaseUrl }: Props) {
  if (disclaimer.type !== DisclaimerType.POWERED_BY) {
    return 'Unsupported disclaimer type';
  }
  return (
    <div className="disclaimerContainer relative flex h-full w-full items-center bg-white px-8 p-4 lg:py-16">
      <div className="content relative flex h-full w-full flex-col items-center">
        {disclaimer.type === DisclaimerType.POWERED_BY && (
          <PoweredByDisclaimer disclaimer={disclaimer} assetsBaseUrl={assetsBaseUrl} />
        )}
      </div>
    </div>
  );
}
